module.exports = "/images/4.png?dfc77504a3a58dca9c88c121b63fd6b3";